"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "card-container global-event-container" };
const _hoisted_2 = { class: "card-content-wrapper" };
const _hoisted_3 = { class: "global-event-title" };
const _hoisted_4 = { class: "global-event-name" };
const _hoisted_5 = { class: "card-content global-event-card-content" };
const _hoisted_6 = {
    key: 0,
    class: "global-event-distance"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardParty = (0, vue_1.resolveComponent)("CardParty");
    const _component_CardRenderData = (0, vue_1.resolveComponent)("CardRenderData");
    const _component_CardDescription = (0, vue_1.resolveComponent)("CardDescription");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.klass)
    }, [
        (0, vue_1.createElementVNode)("div", _hoisted_1, [
            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.createVNode)(_component_CardParty, {
                    class: "card-party--revealed",
                    party: _ctx.revealed
                }, null, 8, ["party"]),
                (0, vue_1.createVNode)(_component_CardParty, {
                    class: "card-party--current",
                    party: _ctx.current
                }, null, 8, ["party"]),
                (0, vue_1.createElementVNode)("div", _hoisted_3, [
                    (0, vue_1.createElementVNode)("span", _hoisted_4, (0, vue_1.toDisplayString)(_ctx.globalEventName), 1)
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_5, [
                    (_ctx.renderData !== undefined)
                        ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderData, {
                            key: 0,
                            renderData: _ctx.renderData
                        }, null, 8, ["renderData"]))
                        : (0, vue_1.createCommentVNode)("", true),
                    (0, vue_1.createVNode)(_component_CardDescription, { item: _ctx.description }, null, 8, ["item"])
                ])
            ])), [
                [_directive_i18n]
            ])
        ]),
        (_ctx.showDistance)
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", _hoisted_6, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.type), 1)
            ])), [
                [_directive_i18n]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.renderSlot)(_ctx.$slots, "default")
    ], 2));
}
